<script lang="ts" setup>
// import { Label } from "@/registry/new-york-v4/ui/label"
import { useFormField } from '../hooks/useFormField';
import type { IFormLabelProps } from '../types/FormLabel';

const props = defineProps<IFormLabelProps>();

const { error, formItemId } = useFormField();
</script>

<template>
  <label
    data-slot="form-label"
    :data-error="!!error"
    :for="formItemId"
    @mousedown="
      event => {
        if (!event.defaultPrevented && event.detail > 1) event.preventDefault();
      }
    "
  >
    <slot />
  </label>
</template>

<style scoped>
label {
  font-size: var(--x-text-14-size);
  font-weight: var(--x-weight-regular);
  line-height: var(--x-text-14-line-height);
  color: var(--x-text-4);
}
</style>
